import { AccountStoreModule as accountStore } from '@/shared/config/store/account-store';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AccessLevelMixin extends Vue {

  protected adOrganizationId: number;

  protected additionalCriteria = [];

  get isEmployee() {
    return accountStore.isEmployee;
  }

  get isVendor() {
    return accountStore.isVendor;
  }

  get organizationInfo() {
    return accountStore.organizationInfo;
  }

  get vendorInfo() {
    return accountStore.vendorInfo;
  }

  get grantedOrgs() {
    return accountStore.grantedOrgs;
  }

  get loginName() {
    return accountStore.userDetails.userLogin;
  }

  get loginUserId() {
    return accountStore.userDetails.id;
  }

  created() {
    console.log(this.grantedOrgs);
    this.adOrganizationId = this.organizationInfo.id;

    if (this.adOrganizationId > 1) {
      if (this.grantedOrgs.has(1)) this.additionalCriteria.push(`adOrganizationId.in=1`);
      this.additionalCriteria.push(`adOrganizationId.in=${this.adOrganizationId}`);
    }

    if (this.isVendor) {
      const vendorId = this.vendorInfo.id;
      this.additionalCriteria.push(`vendorId.equals=${vendorId}`);
    }
  }

  protected updateCriteria(criteria: string[], isOrgTable?: boolean) {
    if (this.isVendor || this.adOrganizationId > 1) {
      if (isOrgTable) {
        this.additionalCriteria = [];
        for (let x of this.grantedOrgs.keys()) {
          this.additionalCriteria.push(`id.in=${x}`)
        }
      }
      return [...criteria, ...this.additionalCriteria];
    }

    return criteria;
  }
}